/** @format */

import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import {
  _$,
  Button,
  Icon,
  Select,
  Option,
  Collapse,
  CollapseItem,
  Dialog,
  Message
} from '@king-design/react'
import { Divider } from 'src/components'
import { ContactGroupUpdate } from 'src/containers/MonitorContacts/constants'
import { CountContext } from '../index'
import ContactGroupDrawer from 'src/containers/MonitorContacts/ContactGroupDrawer'
import ContactGroupTable from 'src/containers/MonitorContacts/ContactGroupTable'
import variable from 'src/static/styles/var'
import { request } from 'src/utils'
import API from 'src/api/ApiContacts'

const ContactGroup: React.FC<{ className?: string }> = ({ className }) => {
  const { groupList, getUserGroup } = useContext(CountContext)
  const [groupUser, setGroupUser] = useState({})
  const [collapseValue, setCollapseValue] = useState<string>()
  const [drawerVisible, setDrawerVisible] = useState<boolean>(false)
  const [curGroup, setCurGroup] = useState<ContactGroupUpdate>({})
  const [userList, setUserList] = useState([])

  useEffect(() => {
    if (groupList?.length && userList?.length) {
      !collapseValue && setCollapseValue(groupList[0].usrgrpid + '')
      const groupUserObject = {}
      groupList.forEach(group => {
        groupUserObject[group.usrgrpid] = []
        userList.forEach(user => {
          const find = user.usergroup?.find(item => {
            return item.usrgrpid === group.usrgrpid
          })
          find && groupUserObject[group.usrgrpid].push(user)
        })
      })
      setGroupUser(groupUserObject)
    }
  }, [groupList, userList])

  useEffect(() => {
    getUserAlertList()
  }, [])

  // 获取所有联系人
  const getUserAlertList = async () => {
    const result = await request(API.getAlertUser, {
      data: { PageIndex: 1, PageSize: 999, Cap: 1 }
    })
    const { data, code } = result
    if (code === 'Success') {
      setUserList(data?.userlist || [])
    }
  }

  // 删除联系组
  const deleteGroup = async id => {
    const result = await request(`${API.delUserGroup}&Id=${id}`, {
      method: 'DELETE'
    })
    const { code, message } = result
    if (code === 'Success') {
      updateGroupList()
      Message.success(message)
    }
  }

  // 更新列表
  const updateGroupList = () => {
    getUserGroup()
    getUserAlertList()
  }

  return (
    <div className={className}>
      <div className="header">
        <Button
          type="primary"
          onClick={() => {
            setDrawerVisible(true)
            setCurGroup({})
          }}
        >
          <Icon className="ion-person-stalker" />
          {_$('新建联系组')}
        </Button>
        <Select value={collapseValue} onChangeValue={value => setCollapseValue(value)}>
          {groupList?.length &&
            groupList.map(({ name, usrgrpid }) => (
              <Option key={usrgrpid} value={usrgrpid + ''}>
                {_$(name)}
              </Option>
            ))}
        </Select>
      </div>
      <Collapse
        value={[collapseValue]}
        onChangeValue={value => {
          !value.includes(collapseValue) &&
            setCollapseValue(Array.isArray(value) ? value[0] : value)
        }}
        accordion
        arrow="left"
        className="marginTop"
      >
        {groupList?.length
          ? groupList.map(item => {
              const { name, usrgrpid, description } = item
              return (
                <CollapseItem
                  key={usrgrpid}
                  value={usrgrpid + ''}
                  slotTitle={
                    <React.Fragment>
                      {name}
                      <div className="collapse-item-right ksc-space">
                        <a
                          className="link"
                          onClick={() => {
                            setCurGroup({
                              ...item,
                              contactIds: groupUser[usrgrpid] || []
                            })
                            setDrawerVisible(true)
                            setCollapseValue(usrgrpid + '')
                          }}
                        >
                          {_$('修改')}
                        </a>
                        <Divider />
                        <a
                          className="link"
                          onClick={() => {
                            setCollapseValue(usrgrpid + '')
                            Dialog.confirm({
                              content: _$('确定删除该联系组吗？')
                            }).then(() => {
                              deleteGroup(usrgrpid)
                            })
                          }}
                        >
                          {_$('删除')}
                        </a>
                      </div>
                    </React.Fragment>
                  }
                >
                  <ContactGroupTable
                    usrgrpid={usrgrpid}
                    name={name}
                    description={description}
                    contactIds={groupUser[usrgrpid]}
                    updateGroupList={updateGroupList}
                  />
                </CollapseItem>
              )
            })
          : null}
      </Collapse>
      <ContactGroupDrawer
        visible={drawerVisible}
        curGroup={curGroup}
        closeDrawer={(update = false) => {
          setCurGroup({})
          setDrawerVisible(false)
          if (update) {
            updateGroupList()
          }
        }}
        userList={userList}
      />
    </div>
  )
}
export default styled(ContactGroup)`
  .collapse-item-right {
    float: right;
  }
  .k-collapse-item.k-active .k-title {
    color: ${variable.primaryColor};
  }
`
